import { render, staticRenderFns } from "./SignUpView.vue?vue&type=template&id=45241ad9&"
import script from "./SignUpView.vue?vue&type=script&lang=ts&"
export * from "./SignUpView.vue?vue&type=script&lang=ts&"
import style0 from "./SignUpView.vue?vue&type=style&index=0&id=45241ad9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports